<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.ក ៥.ខ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.គ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.ឃ.ង.ច
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.ឆ​ ៥.ជ
      </v-tab>
      <v-tab-item>
        <div class="row">
          <div>
            <schoolarea :data="fac_5a" :last_row="1" :title="title[1]" />
          </div>
          <div>
            <schoolconst :data="fac_5b" :title="title[2]" />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <schoolbuilding :data="fac_5c" :title="title[3]" />
          </div>
          <div>
            <p></p>
            <schoolroom :data="fac_5cc" />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <preextoy :data="uti_5d" :title="title[4]" />
          </div>
          <div>
            <handwashing :data="uti_5e" :lastRow="0" :title="title[5]" />
            <!-- LastRow is 0 for pre school only -->
          </div>
        </div>
        <div class="row">
          <div>
            <toilet :data="uti_5f" :title="title[6]" />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <water :data="uti_5g" :title="title[7]" />
          </div>
        </div>
        <div class="row">
          <div>
            <facility :data1="uti_5h1" :data2="uti_5h2" :title="title[8]" />
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import preExternalToy from "@/components/ascf/pre/preExternalToy.vue";
import schoolArea from "@/components/ascf/sharedCom/schoolArea.vue";
import schoolConst from "@/components/ascf/sharedCom/schoolConstruction.vue";
import schoolBuilding from "@/components/ascf/sharedCom/schoolBuilding.vue";
import schoolRoom from "@/components/ascf/sharedCom/schoolRoom.vue";
import handWashing from "@/components/ascf/sharedCom/handwashing.vue";
import toilet from "@/components/ascf/sharedCom/toilet.vue";
import Facility from "@/components/ascf/sharedCom/facility.vue";
import WaterSource from "@/components/ascf/sharedCom/waterSource.vue";

export default {
  props: [
    "title",
    "fac_5a",
    "fac_5b",
    "fac_5c",
    "fac_5cc",
    "uti_5d",
    "uti_5e",
    "uti_5f",
    "uti_5g",
    "uti_5h1",
    "uti_5h2",
  ],
  components: {
    preextoy: preExternalToy,
    schoolarea: schoolArea,
    schoolconst: schoolConst,
    schoolbuilding: schoolBuilding,
    schoolroom: schoolRoom,
    handwashing: handWashing,
    toilet: toilet,
    facility: Facility,
    water: WaterSource,
  },
  data() {
    return {
      active_tab: 0,
    };
  },
  methods: {},
};
</script>
<style scoped>
.row {
  display: flex;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>